import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-40",
  "use": "icon-sheet_icon-40-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-40\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M9.93 12.75l.935 6.222-8.535.278.575-6.284 7.025-.216zM21.026 12.75l1.021 6.218-8.53.282.487-6.28 7.022-.22zM15.215 3.75l1.114 6.214-8.713.286.621-6.286 6.978-.214z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol